import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {MatSelectChange} from "@angular/material/select";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import html2pdf from "html2pdf.js";
import {FullChild} from "../../../../../interfaces/FullChild";
import {Centre} from "../../../../../interfaces/Centres";
import {CentreService} from "../../../../../services/centre.service";
import {ChildService} from "../../../../../components/child/child.service";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {NgxPrintService, PrintOptions} from "ngx-print";
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from "@angular/material/snack-bar";
import {dE} from "@fullcalendar/core/internal-common";
import Editor from "@ckeditor/ckeditor5-build-classic";
import {LogService} from "../../../../../services/log.service";

@Component({
  selector: 'app-add-child-case-study',
  templateUrl: './add-child-case-study.component.html',
  styleUrls: ['./add-child-case-study.component.scss']
})
export class AddChildCaseStudyComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  mSelectedCentre: any;
  selectedChildId: any;
  mChildren!: FullChild[];
  centres$!: Observable<Centre[]>;
  mChildData: any;
  @ViewChild('content') content!: ElementRef;
  photoUrl: string | undefined;
  narrative: string='';
  mId:any
  editMode=false
  children$?: Observable<FullChild[]>

  mSelectedCentreName: string = ''; // For displaying the centre name
  selectedChildFullName: string = ''; // For displaying the child's full name
  diagnosisfetch: any;
  constructor(
    private readonly mCentreService: CentreService,
    private readonly mSnackBar: MatSnackBar,
    private readonly mFirestore: AngularFirestore,
    private  readonly childService: ChildService,
    private route: ActivatedRoute,
    private  mRouter: Router,
    private mLogService : LogService
  ) {
    this.centres$ = this.mCentreService.getAllCentres();

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mId = res['id']
      console.log("mid", this.mId)
      if (this.mId) this.mFirestore.collection(this.env.childCaseStudy).doc(this.mId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
        if (this.mId != undefined) {
          const childData = res;
          this.mChildData = {
            narrative: childData.narrative,
            age: childData.age,
            city: childData.city,
            gender: childData.gender,
            firstName: childData.firstName,
            lastName: childData.lastName,

            diagnosis: childData.diagnosis,
            state: childData.state,
            hospital: childData.hospital,
            admissionDocuments: childData.admissionDocuments, // Process the URL as needed
          }
        }
  })
})

  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      const childId = params.get('id');
      console.log('childId',childId)
      if (childId) {
        // Editing mode
        this.selectedChildId = childId;
        this.editMode = true;
        console.log('into if childId')
        this.fetchChildData(childId);  // Fetch data to populate form for editing
      } else {
        // Adding new case study
        this.editMode = false;// Ensure form is reset for new data entry
      }
    });
  }


  fetchChildData(childId: string): void {
    console.log('int fecth CHildData')
    this.mFirestore.collection(this.env.childCaseStudy).doc(childId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
      console.log('childdata res',res)
      if (res) {
        this.mChildData = []
        console.log(res)
        this.mSelectedCentre = res.centreName;
        this.mSelectedCentreName = res.centreName; // Set for display
        this.selectedChildFullName = `${res.firstName} ${res.lastName}`; // Set for display
        this.diagnosisfetch = res.diagnosis
        console.log(this.mSelectedCentre);
        console.log(this.mChildData);
          const data = {
          narrative: res.narrative,
          childCode:res.childCode,
          mSelectedCentre:res.centreName,
          childName:res.childName,
          age: res.age,
          city: res.city,
          dateOfAdmission: res.date,
          gender: res.gender,
          firstName: res.firstName,
          lastName: res.lastName,
          diagnosis: res.diagnosis,
          state: res.state,
          hospital: res.hospital,
          admissionDocuments: res.admissionDocuments, // Process the URL as needed
        }
        this.mChildData.push(data);
        this.narrative = res.narrative;
        this.mSelectedCentre = res.centreName; // Pre-select the centre
        this.selectedChildId = res.childCode; // Pre-select the child if needed
        console.log( this.selectedChildId)

      }

    });
  }

  onCentreSelected($event: MatSelectChange): void {
    this.mChildren = [];
    this.mSelectedCentre = $event.value;

    this.children$ = this.childService.getAlloteCaseStudydChildListByCenter(this.mSelectedCentre);

    this.children$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      // Add allotted children (already filtered for age >= 3)
      const allottedChildren = [...res];

      // Fetch and add discharged children
      this.childService.getDischargedChildListByCenterAboveThreeWithinThreeDaysEducation(this.mSelectedCentre)
        .then(dischargedRes => {
          const dischargedChildren = dischargedRes.docs
            .map(x => x.data() as FullChild)
            .filter(child => child.age >= 3); // Filter once

          console.log('DISCHARGED CHILDREN IN SELECT', dischargedChildren.length);

          // Combine all children and deduplicate by childCode
          const allChildren = [...allottedChildren, ...dischargedChildren];

          // Use Map to deduplicate based on childCode
          const uniqueChildrenMap = new Map<string, FullChild>();
          allChildren.forEach(child => {
            const key = child.childCode || child.id || `${child.firstName}_${child.lastName}`;
            if (!uniqueChildrenMap.has(key)) {
              uniqueChildrenMap.set(key, child);
            }
          });

          // Convert Map back to array and sort
          this.mChildren = Array.from(uniqueChildrenMap.values())
            .sort((a, b) =>
              a.firstName.localeCompare(b.firstName) ||
              a.lastName.localeCompare(b.lastName)
            );

          console.log(`Total unique children: ${this.mChildren.length}`);
        })
        .catch(error => {
          console.error('Error fetching discharged children:', error);
        });
    });
  }

  // onChildSelect($event: MatSelectChange): void {
  //   console.log($event.value)
  //   console.log($event.value?.id)
  //   this.selectedChildId = $event.value?.id;
  // }
  onChildSelect($event: MatSelectChange): void {
    this.selectedChildId = $event.value?.childCode || $event.value?.id;
    if (!this.selectedChildId) return;

    this.mFirestore.collection(this.env.child, ref =>
      ref.where('childCode', '==', this.selectedChildId)
    )
      .valueChanges()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((res: any[]) => {
        this.mChildData = res;
        console.log("Loaded child data:", this.mChildData);
      });
  }


  searchChildByCode(): void {
    this.mFirestore.collection(this.env.child, ref => ref.where('childCode', '==', `${this.selectedChildId}`)).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
      this.mChildData = res;

    });
  }

  getChildPhotoUrl(admissionDocuments: any[]): string {
    const childPhotoDocument = admissionDocuments?.find(doc => doc.description === 'Family Photo');
    return childPhotoDocument ? childPhotoDocument.fileUrl : '';
  }

  printContent(): void {
    const content = this.content.nativeElement;
    const options = {
      margin: 10,
      filename: 'Report.pdf',
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 1},
      jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'}
    };
    html2pdf().from(content).set(options).save();
  }

  printDoc(): void {
    const content = this.content.nativeElement;
    setTimeout(() => {
      html2canvas(content).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF();
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        doc.addImage(imgData, 'PNG', 15, 15, pdfWidth - 30, pdfHeight - 30);
        doc.save('document.pdf');
      }).catch(err => {
        console.error('html2canvas Error:', err);
      });
    }, 1000);
  }

  submit(): void {
    // Add Mode
    console.log(this.selectedChildId)
    console.log(this.mChildData)
    console.log(this.editMode)
    if (this.selectedChildId && !this.editMode) {
      const caseStudy = {
        childCode: this.mChildData[0]?.childCode,
        narrative: this.narrative,
        age: this.mChildData[0]?.age,
        city: this.mChildData[0]?.city,
        gender: this.mChildData[0]?.gender,
        firstName: this.mChildData[0]?.firstName,
        lastName: this.mChildData[0]?.lastName,
        childName: `${this.mChildData[0]?.firstName || ''} ${this.mChildData[0]?.lastName || ''}`.trim(),
        diagnosis: this.mChildData[0]?.diagnosisSelected?.[0],
        state: this.mChildData[0]?.state,
        hospital: this.mChildData[0]?.hospital,
        centreName: this.mChildData[0]?.centreName,
        admissionDocuments: this.getChildPhotoUrl(this.mChildData[0]?.admissionDocuments || []),
        date: new Date()
      };

      console.log(caseStudy);

      this.mFirestore.collection(this.env.childCaseStudy).add(caseStudy)
        .then(() => {
          this.mSnackBar.open('Data saved successfully', '', {
            duration: 3000,
            panelClass: 'success'
          });
          const activity = {
            date: new Date().getTime(),
            section: 'Child Case Study',
            action: 'Submit',
            description: `Child Case Study submitted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);
          this.mRouter.navigateByUrl('home/reports/child-case-study'); // Navigate after saving
        })
        .catch(error => {
          console.error('Error submitting case study:', error);
        });

      return; // Ensure that once Add Mode is processed, we stop execution.
    }

    // Edit Mode
    if (this.selectedChildId && this.editMode) {
      const caseStudy = {
        childCode: this.mChildData[0]?.childCode,
        narrative: this.narrative,
        age: this.mChildData[0]?.age,
        city: this.mChildData[0]?.city,
        gender: this.mChildData[0]?.gender,
        firstName: this.mChildData[0]?.firstName,
        lastName: this.mChildData[0]?.lastName,
        childName: `${this.mChildData[0]?.firstName || ''} ${this.mChildData[0]?.lastName || ''}`.trim(),
        diagnosis: this.diagnosisfetch,
        state: this.mChildData[0]?.state,
        hospital: this.mChildData[0]?.hospital,
        centreName: this.mSelectedCentreName,
        admissionDocuments: this.mChildData[0]?.admissionDocuments || [],
        date: new Date()
      };

      // Update the existing document
      this.mFirestore.collection(this.env.childCaseStudy).doc(this.mId).update(caseStudy)
        .then(() => {
          this.mSnackBar.open('Data updated successfully', '', {
            duration: 3000,
            panelClass: 'success'
          });
          this.mRouter.navigateByUrl('home/reports/child-case-study'); // Navigate after saving
        })
        .catch(error => {
          console.error('Error updating case study:', error);
          this.mSnackBar.open('Error updating case study. Please try again.', '', {
            duration: 3000,
            panelClass: 'error'
          });
        });

      return; // Stop further execution after Edit Mode
    }

    // Fallback if no child is selected
    this.mSnackBar.open('Please select a child before submitting the case study.', '', {
      duration: 3000,
      panelClass: 'error'
    });
  }



  printDoc2(): void {
    const previewElement = document.getElementById('previewChildCaseStudyReports');
    if (!previewElement) {
      console.error('Element with ID "preview" not found.');
      return;
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Child Case Study</title>
            <style>
              @media print {
                body { margin: 0; padding: 0; }
                .page { padding: 10px; margin: 10px; page-break-after: always; }
                .page:before {
                  content: '';
                  position: fixed;
                  top: 0; left: 0; right: 0; bottom: 0;
                  border: 1px solid #000;
                  pointer-events: none;
                  z-index: -1;
                }
              }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            <div class="page">${previewElement.innerHTML}</div>
          </body>
        </html>
      `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

    protected readonly Editor = Editor;

}
